import * as React from "react";
import { Link } from "gatsby";
//import { CookiesProvider, useCookies } from 'react-cookie';
//import CookiesConsent from './cookies-consent';
import SocialLinks from "./social-links";
import * as blogStyles from "../blog.module.css";

const CommonLayout = ({ children, avatar }) => {
  // const [cookies, setCookie] = useCookies(['accept-cookies']);
  // const [cookiesAccepted, setCookiesAccepted] = React.useState(true);

  // React.useEffect(() => {
  //    if (cookies['accept-cookies'] === 'Yes') {
  //       setCookiesAccepted(true);
  //    } else {
  //       setCookiesAccepted(false);
  //    }
  // }, [cookies, cookiesAccepted]);

  return (
    // <CookiesProvider>
    <main>
      <header>
        <nav className={blogStyles.siteNav}>
          <Link className={blogStyles.siteTitle} to="/">
            <img src={avatar} alt="Avatar" className={blogStyles.siteAvatar} />
            <span>Nourdine Labib</span>
          </Link>
          <a
            className={blogStyles.siteAbout}
            href="https://nourdinelabib.com"
            target="_blank"
            rel="noreferrer"
          >
            <span>About</span>
          </a>
        </nav>
      </header>
      {children}
      <footer>
        <a
          href="https://nourdinelabib.com"
          target="_blank"
          rel="noreferrer"
          className={blogStyles.footerLink}
        >
          &copy; {new Date().getFullYear()} <b>Nourdine Labib</b>
        </a>
        <SocialLinks />
      </footer>
    </main>
    // {/* {cookiesAccepted ? null : <CookiesConsent setCookie={setCookie} />} */}
    // </CookiesProvider>
  );
};

export default CommonLayout;
